import { api } from './configs/axiosConfig';

const endPoint = "/pos-tables";

export const posTableAPI = {
    getPOSTables: async function () {
        const reponse = await api.request({
            url: `${endPoint}`,
            method: 'GET'
        });

        return reponse.data;
    }
}